import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { connect } from "react-redux"
import swal from 'sweetalert'

import Tooltip from "components/Tooltip"
import { GenericTableHeader } from "components/GenericTable"

import {
    MAX_NUM_SEARCH_RESULTS_SEARCH_VIS_SHORT_INTERVAL,
    DAY_STRING,
    WEEK_STRING,
    MONTH_STRING,
    YEAR_STRING,
} from "imports/desktopConstants"

import { lineSidebarProps } from 'search-new/selectors'
import {
    GenericSidebarButton,
    DownloadButtonGroup,
    ResetFiltersButton,
} from 'search-new/components/Visualization/VisualizationSidebars/SidebarButtons'
import { VisualizationLayerTable } from 'search-new/components/Visualization/VisualizationSidebars/SidebarTables'
import { MEDIA_FLV } from "shared/imports/sharedConstants"

export class LineSidebar extends Component {
    renderIntervalButtons = () => {
        const defaultButtonId = MONTH_STRING
        const tooltipString = "Add more filters for more granular visualization."

        const isArticleFLV = this.props.uniqueFlvId === MEDIA_FLV  // Articles can handle so many more results a la Elasticsearch.
        const maxed_out = !isArticleFLV && this.props.currentCount >= MAX_NUM_SEARCH_RESULTS_SEARCH_VIS_SHORT_INTERVAL
        const buttons = [
            {
                text: "Day",
                id: DAY_STRING,
                disabled: this.props.disableButtons || maxed_out,
            },
            {
                text: "Week",
                id: WEEK_STRING,
                disabled: this.props.disableButtons || maxed_out,
            },
            {
                text: "Month",
                id: MONTH_STRING,
                disabled: this.props.disableButtons,
            },
            {
                text: "Year",
                id: YEAR_STRING,
                disabled: this.props.disableButtons,
            },
        ]

        return buttons.map(btn => {
            const active = (this.props.secondaryGraphKeys.get('interval') || defaultButtonId) === btn.id

            const callback = !btn.disabled && !active
                ? () => {
                    if (this.props.storedGraphs.size) {
                        swal({
                            title: "Changing time intervals will delete your stored graphs! Are you sure?",
                            buttons: ['Cancel', true]
                        }).then(confirm => {
                            if (confirm) {
                                this.props.setSecondaryGraphKeys({ interval: btn.id })
                                this.props.deleteAllStoredGraphs()
                            }
                        })
                    } else {
                        this.props.setSecondaryGraphKeys({ interval: btn.id })
                    }
                }
                : () => {}

            const buttonComponent = (
                 <button
                    key={btn.id}
                    className={classNames(
                        'btn',
                        'btn-default-white',
                        'interval',
                        'no-top-border-radius',
                        {
                            disabled: btn.disabled,
                            active,
                        }
                    )}
                    onClick={callback}
                >
                    { btn.text }
                </button>
            )

            return btn.disabled
                ? <Tooltip key={btn.id} label={tooltipString}>{buttonComponent}</Tooltip>
                : buttonComponent
        })
    }

    resetGraphCallback = () => {
        this.props.setSecondaryGraphKeys({ interval: MONTH_STRING })
    }

    undoZoom = () => this.props.updateFilter({
        dateStart: this.props.maximumDateRange.start,
        dateEnd: this.props.maximumDateRange.end,
    })

    // "undo zoom" button is active when dates are smaller than the maximum data.
    // 'reset graph' button is active when there are any dates in search at all.
    render() {
        return (
            <div className="sidebar-controls">
                <div>
                    <GenericTableHeader label="Frequency by..." />
                    <div className="btn-group variable-buttons">
                        {this.renderIntervalButtons()}
                    </div>
                </div>
                <div className="btn-group variable-buttons">
                    <GenericSidebarButton
                        onClick={this.undoZoom}
                        label="Undo Zoom"
                        disabled={!this.props.shouldShowUndoZoom || this.props.disableButtons}
                        tooltipText="View all data available"
                        noBlock
                    />
                    <ResetFiltersButton
                        uniqueFlvId={this.props.uniqueFlvId}
                        uniqueVizSceneId={this.props.uniqueVizSceneId}
                        callback={this.resetGraphCallback}
                        label="Reset Graph"
                        tooltipText="Clear all date filters. This will reset the graph time frequency to Month."
                        disabled={this.props.disableButtons}
                        noBlock
                    />
                </div>
                <DownloadButtonGroup
                    uniqueFlvId={this.props.uniqueFlvId}
                    uniqueVizSceneId={this.props.uniqueVizSceneId}
                    disabled={this.props.disableButtons}
                />
                <VisualizationLayerTable
                    uniqueFlvId={this.props.uniqueFlvId}
                    uniqueVizSceneId={this.props.uniqueVizSceneId}
                    disabled={this.props.disableButtons}
                />
            </div>
        )
    }
}

LineSidebar.propTypes = {
    uniqueFlvId: PropTypes.string.isRequired,
    uniqueVizSceneId: PropTypes.string.isRequired,
    storedGraphs: PropTypes.object.isRequired,
    currentCount: PropTypes.number.isRequired,
    setSecondaryGraphKeys: PropTypes.func.isRequired,
    secondaryGraphKeys: PropTypes.object.isRequired,
    shouldShowUndoZoom: PropTypes.bool,
    disableButtons: PropTypes.bool,
}

export default connect(lineSidebarProps, null)(LineSidebar)
